storefrontApp.service('elasticService', ['$http', 'configs', function ($http, configs) {
    var productSearchSynonymsCache = null;

    function isUrlSearchPhrase(term) {
        var parts = (term || "").split("-");
        return parts.length > 1 && parts.every(function (part) {
            return /^[a-zA-Z]{2,}$/.test(part);
        });
    }

    function decodeUrlSearchTerm(term) {
        var decoded = (term || "").toString().trim();
        if (!decoded) {
            return "";
        }

        try {
            decoded = decodeURIComponent(decoded.replace(/\+/g, " "));
        } catch (e) {
            // Leave term as-is when it is already decoded.
        }

        if (isUrlSearchPhrase(decoded)) {
            return decoded.replace(/-/g, " ");
        }

        return decoded;
    }

    function normalizeProductSearchToken(value) {
        return (value || "")
            .toString()
            .trim()
            .toLowerCase()
            .replace(/_+/g, " ")
            .replace(/\s+/g, " ");
    }

    function fixCommonProductSearchTypos(searchTerm) {
        var t = (searchTerm || "").trim();
        if (!t) {
            return "";
        }
        t = t.replace(/\bdsigns\b/gi, "designs");
        t = t.replace(/\bdsign\b/gi, "design");
        t = t.replace(/\bdesings\b/gi, "designs");
        t = t.replace(/\bdesgin\b/gi, "design");
        t = t.replace(/\bdesignes\b/gi, "designs");
        return t.replace(/\s+/g, " ").trim();
    }

    function getProductSearchCompactPhraseMap() {
        var defaults = {
            freestandinglace: "free standing lace",
            inthehoop: "in the hoop",
        };
        var extra = window.__searchCompactPhraseMap;
        if (extra && typeof extra === "object") {
            return angular.extend({}, defaults, extra);
        }
        return defaults;
    }

    function expandProductSearchCompactPhraseTokens(tokens, phraseMap) {
        var keys = Object.keys(phraseMap || {}).sort(function (a, b) {
            return b.length - a.length;
        });
        var out = [];
        for (var i = 0; i < tokens.length; i++) {
            var t = tokens[i];
            if (!t) {
                continue;
            }
            var lookupKey = t.replace(/[_-]/g, "");
            var phrase = null;
            for (var k = 0; k < keys.length; k++) {
                if (lookupKey === keys[k]) {
                    phrase = phraseMap[keys[k]];
                    break;
                }
            }
            if (phrase) {
                var parts = phrase.trim().split(/\s+/);
                for (var p = 0; p < parts.length; p++) {
                    out.push(parts[p]);
                }
            } else {
                out.push(t);
            }
        }
        return out;
    }

    function getProductSearchContextualAbbrevRules() {
        var defaults = [
            {
                abbrev: "ith",
                phrase: "in the hoop",
                allowedFollowing: {
                    design: true,
                    designs: true,
                    embroidery: true,
                    machine: true,
                    machines: true,
                    project: true,
                    projects: true,
                    quilting: true,
                    applique: true,
                    pattern: true,
                    patterns: true,
                    motif: true,
                    motifs: true,
                    pack: true,
                    packs: true,
                    font: true,
                    fonts: true,
                    kit: true,
                    kits: true,
                    collection: true,
                    collections: true,
                    software: true,
                },
            },
            {
                abbrev: "fsl",
                phrase: "free standing lace",
                allowedFollowing: {
                    design: true,
                    designs: true,
                    embroidery: true,
                    lace: true,
                    pattern: true,
                    patterns: true,
                    motif: true,
                    motifs: true,
                    digitizing: true,
                    pack: true,
                    packs: true,
                    quilting: true,
                    collection: true,
                    collections: true,
                },
            },
        ];

        var extra = window.__searchContextualAbbrevRules;
        if (!angular.isArray(extra) || !extra.length) {
            return defaults;
        }

        var byAbbrev = {};
        defaults.forEach(function (rule) {
            byAbbrev[rule.abbrev] = angular.copy(rule);
        });

        extra.forEach(function (entry) {
            if (!entry || !entry.abbrev) {
                return;
            }
            var ab = normalizeProductSearchToken(entry.abbrev);
            if (!ab) {
                return;
            }
            var target = byAbbrev[ab] || {
                abbrev: ab,
                phrase: "",
                allowedFollowing: {},
            };
            if (entry.phrase) {
                target.phrase = normalizeProductSearchToken(entry.phrase);
            }
            target.allowedFollowing = target.allowedFollowing || {};
            if (angular.isArray(entry.allowedFollowing)) {
                entry.allowedFollowing.forEach(function (tok) {
                    var t = normalizeProductSearchToken(tok);
                    if (t) {
                        target.allowedFollowing[t] = true;
                    }
                });
            }
            byAbbrev[ab] = target;
        });

        return Object.keys(byAbbrev).map(function (key) {
            return byAbbrev[key];
        });
    }

    function expandProductSearchContextualAbbrevsInQuery(searchTerm) {
        var s = (searchTerm || "").trim().replace(/\s+/g, " ");
        if (!s) {
            return "";
        }

        var compactWhole = {
            inthehoop: "in the hoop",
            freestandinglace: "free standing lace",
        };
        if (!/\s/.test(s) && compactWhole[s]) {
            return compactWhole[s];
        }

        var rules = getProductSearchContextualAbbrevRules();
        if (!rules.length) {
            return s;
        }

        var tokens = s.split(" ");
        var out = [];
        var i = 0;
        while (i < tokens.length) {
            var matched = false;
            for (var r = 0; r < rules.length; r++) {
                var rule = rules[r];
                var ab = rule.abbrev;
                if (!ab || tokens[i] !== ab) {
                    continue;
                }

                var next = tokens[i + 1];
                var allow = rule.allowedFollowing || {};
                var onlyToken = tokens.length === 1;
                var followingOk = next && allow[next];

                if (onlyToken || followingOk) {
                    var phraseText = (rule.phrase || "").trim();
                    if (!phraseText) {
                        continue;
                    }
                    var parts = phraseText.split(/\s+/);
                    for (var p = 0; p < parts.length; p++) {
                        out.push(parts[p]);
                    }
                    i++;
                    matched = true;
                    break;
                }
            }
            if (!matched) {
                out.push(tokens[i]);
                i++;
            }
        }

        return out.join(" ").replace(/\s+/g, " ").trim();
    }

    function getProductSearchSynonyms() {
        if (angular.isArray(productSearchSynonymsCache)) {
            return productSearchSynonymsCache;
        }

        var defaults = [
            { from: "emb", to: "embroidery" },
            { from: "embdes", to: "embroidery designs" },
            { from: "embdesign", to: "embroidery design" },
            { from: "embdesigns", to: "embroidery designs" },
            { from: "embroiderydesign", to: "embroidery design" },
            { from: "embroiderydesigns", to: "embroidery designs" },
        ];

        var payload = window.__searchSuggestionSynonymsConfig || {};
        var configured = angular.isArray(payload)
            ? payload
            : angular.isArray(payload.rules)
            ? payload.rules
            : [];

        var merged = defaults.concat(configured);
        var expanded = [];
        var seen = {};

        for (var i = 0; i < merged.length; i++) {
            var entry = merged[i] || {};
            var from = normalizeProductSearchToken(entry.from);
            var to = normalizeProductSearchToken(entry.to);
            if (!from || !to) {
                continue;
            }

            var directKey = from + "=>" + to;
            if (!seen[directKey]) {
                seen[directKey] = true;
                expanded.push({ from: from, to: to });
            }

            var compactFrom = from.replace(/\s+/g, "");
            if (compactFrom !== from) {
                var compactFromKey = compactFrom + "=>" + to;
                if (!seen[compactFromKey]) {
                    seen[compactFromKey] = true;
                    expanded.push({ from: compactFrom, to: to });
                }
            }

            var compactTo = to.replace(/\s+/g, "");
            if (compactTo && compactTo !== from) {
                var compactToKey = compactTo + "=>" + to;
                if (!seen[compactToKey]) {
                    seen[compactToKey] = true;
                    expanded.push({ from: compactTo, to: to });
                }
            }
        }

        productSearchSynonymsCache = expanded;
        return productSearchSynonymsCache;
    }

    function expandProductSearchSynonyms(searchTerm) {
        var normalized = (searchTerm || "").trim().replace(/\s+/g, " ");
        if (!normalized) {
            return "";
        }

        normalized = expandProductSearchContextualAbbrevsInQuery(normalized);

        var synonyms = getProductSearchSynonyms();
        if (!synonyms.length) {
            return normalized;
        }

        for (var i = 0; i < synonyms.length; i++) {
            var entry = synonyms[i] || {};
            if (!entry.from || !entry.to) {
                continue;
            }

            var from = normalizeProductSearchToken(entry.from);
            var to = normalizeProductSearchToken(entry.to);
            if (!from || !to) {
                continue;
            }

            var escaped = from.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            normalized = normalized.replace(new RegExp("\\b" + escaped + "\\b", "g"), to);
        }

        return normalized.replace(/\s+/g, " ").trim();
    }

    function splitProductSearchTokenByVocabulary(token, vocabulary) {
        if (!token || token.length < 8) {
            return token;
        }

        for (var i = 3; i <= token.length - 3; i++) {
            var left = token.slice(0, i);
            var right = token.slice(i);

            if (vocabulary[left] && vocabulary[right]) {
                return left + " " + right;
            }

            if (vocabulary[left]) {
                var splitRight = splitProductSearchTokenByVocabulary(right, vocabulary);
                if (splitRight.indexOf(" ") > -1 || vocabulary[splitRight]) {
                    return left + " " + splitRight;
                }
            }
        }

        return token;
    }

    function splitProductSearchCompoundWords(searchTerm) {
        var normalized = (searchTerm || "").trim();
        if (!normalized) {
            return "";
        }

        var vocabulary = {
            in: true,
            the: true,
            hoop: true,
            free: true,
            standing: true,
            lace: true,
            embroidery: true,
            design: true,
            designs: true,
            file: true,
            files: true,
            download: true,
            downloads: true,
            pattern: true,
            patterns: true,
            custom: true,
            digitizing: true,
            font: true,
            fonts: true,
            pack: true,
            packs: true,
            quilting: true,
            software: true,
            supplies: true,
            heat: true,
            transfer: true,
            svg: true,
            dxf: true,
        };

        return normalized
            .split(/\s+/)
            .map(function (token) {
                return splitProductSearchTokenByVocabulary(token, vocabulary);
            })
            .join(" ");
    }

    function normalizeProductSearchText(searchTerm) {
        var normalized = decodeUrlSearchTerm(searchTerm);
        if (!normalized) {
            return "";
        }

        normalized = normalized
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/\s+/g, " ")
            .toLowerCase();

        var tokens = normalized.split(" ");
        tokens = expandProductSearchCompactPhraseTokens(tokens, getProductSearchCompactPhraseMap());
        normalized = tokens.join(" ");

        normalized = normalized
            .replace(/_+/g, " ")
            .replace(/\s+/g, " ");

        normalized = expandProductSearchSynonyms(normalized);
        normalized = splitProductSearchCompoundWords(normalized);
        return fixCommonProductSearchTypos(normalized);
    }

    function buildSharedProductSearchBoolQuery(searchTerm, definitionName, rawSearchTerm) {
        var normalizedTerm = (searchTerm || "").toLowerCase().trim();
        var compactTerm = normalizedTerm.replace(/[\s-]+/g, "");
        var rawTerm = (rawSearchTerm || "").toLowerCase().trim();
        var rawCompactTerm = rawTerm.replace(/[\s-]+/g, "");
        var mustFilters = [{ "range": { "listPrice": { "gt": 0 } } }];
        var shouldQueries = [
            {
                "match_phrase": {
                    "name": {
                        "query": normalizedTerm,
                        "boost": 10
                    }
                }
            },
            {
                "multi_match": {
                    "query": normalizedTerm,
                    "operator": "and",
                    "fields": [
                        "name^6",
                        "designKeywords^3",
                        "itemId^8",
                        "productId^8"
                    ]
                }
            }
        ];

        if (compactTerm && compactTerm !== normalizedTerm) {
            shouldQueries.push({
                "multi_match": {
                    "query": compactTerm,
                    "operator": "and",
                    "fields": [
                        "name^4",
                        "designKeywords^2",
                        "itemId^6",
                        "productId^6"
                    ]
                }
            });
        }

        if (rawTerm && rawTerm !== normalizedTerm) {
            shouldQueries.push({
                "multi_match": {
                    "query": rawTerm,
                    "operator": "and",
                    "fields": [
                        "itemId^10",
                        "productId^10"
                    ]
                }
            });
        }

        if (rawCompactTerm && rawCompactTerm !== compactTerm && rawCompactTerm !== rawTerm) {
            shouldQueries.push({
                "multi_match": {
                    "query": rawCompactTerm,
                    "operator": "and",
                    "fields": [
                        "itemId^10",
                        "productId^10"
                    ]
                }
            });
        }

        if ((definitionName || "").toLowerCase() !== "all") {
            mustFilters.push({ "term": { "definitionName": definitionName } });
        }

        return {
            "bool": {
                "filter": mustFilters,
                "should": shouldQueries,
                "minimum_should_match": 1
            }
        };
    }

    return {
        //#region Helper Functions
        getElasticData: function (request, baseUrl) {
            if (window.__env && window.__env.elasticBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl ? baseUrl : configs.elasticBaseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        getKeywordsElasticData: function (request, baseUrl) {
            if (window.__env && window.__env.elasticKeywordsBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl ? baseUrl : configs.elasticKeywordsBaseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        getOrdersLineItemElasticData: function (request, baseUrl) {
            if (window.__env && window.__env.elasticOrdersBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl ? baseUrl : configs.elasticOrdersBaseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        //#endregion

        //#region Homepage Elastic Queries
        buildNewArrivalsRequest: function (prdDefs, size) {
                size = size || 100;
                if (angular.isDefined(prdDefs) && prdDefs.length > 0) {
                    var prdDefObj = [];
                    prdDefs.map(function (def) {
                        prdDefObj.push({
                            "term": {
                                "definitionName": def
                            }
                        })
                    });
    
                    return (
                        '{"query":{"bool":{"must":[{"range":{"listPrice":{"gt":0}}},{"bool":' +
                        '{"should":' + JSON.stringify(prdDefObj) + '}}]}},"size":0,' +
                        '"aggs":{"definitions":{"terms":{"field":"definitionName"},"aggs":{"topByDefinitions":' +
                        '{"top_hits":{"sort":[{"yearCreated":{"order":"desc"}}],"size":' + size + ',"_source":{"includes":' +
                        '["brand", "catalog", "name", "listPrice", "salePrice", "clubPrice", "itemId", "variants.variantId", "variants.numberOfDesigns", "isBuyable", "definitionName", "rating", "saleRank"]}}}}}}}'
                    );
                }
                return null;
          
        },
        //#endregion

        //#region Filter by Category List Keyword
        buildCategoryListKeywordRequest: function (definitionName, keyword, noiseKeyword) {
            return (
                '{"query":{"bool":{"must":[' +
                ((definitionName && definitionName.length > 0) ? '{"term":{"definitionName":{"value":"' + definitionName + '"}}},' : '') +
                '{"term":{"categoriesList.keyword":{"value":"' + keyword + '"}}}]' + (noiseKeyword && noiseKeyword.length > 0 ? ',"must_not":[{"term":{"categoriesList.keyword":{"value":"' + noiseKeyword + '"}}}]' : '') +
                '}},"size":0,"aggs":{"items":{"top_hits":{"size":50,"sort":[{"yearCreated": "desc"},{"saleRank": "desc"},{"rating": "desc"}],"_source":{"includes":["brand","catalog","name","listPrice","salePrice","itemId","variants.variantId","isBuyable","definitionName","rating","saleRank"]}}}}}'
            );
        },
        //#endregion

        //#region Top Picks
        buildTopPicksRequest: function () {
                return (
                    req = '{"track_total_hits": true, "query": { "bool": { "must": [ { "term": { "definitionName": { "value": "StockDesign" } } }, { "range": { "listPrice": { "gt": 0 } } } ] } },' +
                    ' "size": 0, "aggs": { "top_picks": { "terms": { "field": "definitionName" },' +
                    ' "aggs": { "top_picks": { "top_hits": { "sort": [ { "yearCreated": { "order": "desc" } } ], "size": 100, "_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants.variantId", "isBuyable", "definitionName" ] } } } } } } }'
                );
        },

        buildDefaultTopPicksRequest: function () {
                return (
                    req = '{"track_total_hits": true, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should": [ { "term": { "definitionName": "StockDesign" } }, { "term": { "definitionName": "Font" } }, { "term": { "definitionName": "DesignPack" } } ] } } ] } },' +
                    '"size": 0, "aggs": { "definitions": { "terms": { "field": "definitionName" }, "aggs": { "topByDefinitions": { "top_hits": { "sort": [ { "saleRank": { "order": "desc" } } ], "size": 25,' +
                    '"_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants.variantId", "isBuyable", "definitionName" ] } } } } } } }'
                );
           
        },

        buildDefaultStockDesignsRequest: function () {
                return (
                    req = '{"track_total_hits": true, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should": [ { "term": { "definitionName": "StockDesign" } } ] } } ] } },' +
                    '"size": 0, "aggs": { "definitions": { "terms": { "field": "definitionName" }, "aggs": { "topByDefinitions": { "top_hits": { "sort": [ { "saleRank": { "order": "desc" } } ], "size": 100,' +
                    '"_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants.variantId", "isBuyable", "definitionName" ] } } } } } } }'
                );
        },

        buildDefaultOtherProductsRequest: function () {
            var definitionTerms = [];
                    angular.forEach(
                        ["Font", "DesignPack"],
                        function (def) {
                            definitionTerms.push({
                                term: { "definitionName": def }
                            });
                        });
                    var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable","specEmbeddingVector","themeEmbeddingVector"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                        '{ "bool": { "should":' + angular.toJson(definitionTerms) + '} } ] } }, "size": 25 ,"sort":[{"saleRank":{"order":"desc"}}] } ';
                    return request;
           
        },

        buildPDFPatternsProductsRequest: function () {
            var patternTerms = [];
                    angular.forEach(
                        ["Sewing PDF Patterns", "Clothing PDF Patterns", "Crochet PDF Patterns", "Quilting PDF Patterns", "Cross Stitch PDF Patterns", "Knitting PDF Patterns", "Hand Embroidery", "Foundation Paper Piecing PDF Patterns"],
                        function (def) {
                            patternTerms.push({
                                term: { "definitionName": def }
                            });
                        });
                    var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable","specEmbeddingVector","themeEmbeddingVector"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                        '{ "bool": { "should":' + angular.toJson(patternTerms) + '} } ] } }, "size": 25 ,"sort":[{"saleRank":{"order":"desc"}}] }';
                    return request;
          
        },

        buildShippableProductsRequest: function () {
            var shippingTerms = [];
                angular.forEach(
                    ["Supplies", "Equipment", "Embroiderable", "Quilting", "Thread", "CDPackage", "Education", "Collection", "Software"],
                    function (def) {
                        shippingTerms.push({
                            term: { "definitionName": def }
                        });
                    });
                var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable","specEmbeddingVector","themeEmbeddingVector"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should":' + angular.toJson(shippingTerms) + '} } ] } }, "size": 25 ,"sort":[{"saleRank":{"order":"desc"}}] }';
                return request;
        },

        buildRecentlyViewedFillers: function(prdDefs,sizeReq){
            var prdDefObj = [];
                if (angular.isDefined(prdDefs) && prdDefs.length > 0) {
                    prdDefs.map(function (def) {
                        prdDefObj.push({
                            "term": {
                                "definitionName": def
                            }
                        })
                    });
                }
                var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable","specEmbeddingVector","themeEmbeddingVector"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should":' + angular.toJson(prdDefObj) + '} } ] } }, "size": '+ sizeReq +' ,"sort":[{"saleRank":{"order":"desc"}}] }';
                return request;
        
        },

        buildProductByIdsRequest: function (searchTerm) {
            return (
                req = '{"track_total_hits": true, "query":{"ids":{"values":' + searchTerm + '}}}'
            );
        },
        //#endregion

        //#region Associated Packs
        buildAssociatedPacksRequest: function (productId) {
            return (
                req = '{ "query": { "wildcard": { "variants.associatedItemsList": { "value": "' + productId.toLowerCase() + '" } } } }'
            );
        },
        //#endregion

        //#region AssociatedItems
        buildAssociatedItemsRequest: function (associatedItems) {
            return (
                req = '{ "query": { "terms": { "_id":' + angular.toJson(associatedItems) + ' } }, "size": ' + associatedItems.length + ' }'
            );
        },

        //#region Product Info
        buildProductInfoRequest: function (productId, hasExcludes, hasIncludes, hasMultiple) {
            if (angular.isDefined(productId)) {
                var req = {};
                if(hasMultiple){
                    req = {
                        _source: {
                            "excludes": [],
                            "includes": []
                        },
                        query:
                        {
                            "terms": {
                                _id: []
                            }
                        }
                    }
                    productId.map(function(m){
                        req.query.terms._id.push(m.toLowerCase())
                    });
                }
                else{
                    if(Array.isArray(productId)){
                        productId = productId[0];
                    }
                    req = {
                        _source: {
                            "excludes": [],
                            "includes": []
                        },
                        "query":
                        {
                            "terms": { "_id": [ productId ] }
                        }
                    }
                }
                if (hasExcludes && Array.isArray(hasExcludes)) {
                    hasExcludes.map(function(m){
                        req._source.excludes.push(m)
                    });
                }
                if (hasIncludes && Array.isArray(hasIncludes)) {
                    hasIncludes.map(function(m){
                        req._source.includes.push(m)
                    });
                }
                return(
                    req = (
                        JSON.stringify(req)
                    )
                );
            }
            else {
                return (null);
            }
        },

        buildVariantTabContentRequest:function(productId,variantId){
            if(angular.isDefined(productId) && angular.isDefined(variantId))
                {
                    return(
                        req = '{"_source":false,"query":{"bool":{"must":[{"terms":{"_id":["'+ productId +'"]}}]}},"script_fields": { "filtered_variants": {"script": {"source": "def variants = params[\'_source\'][\'variants\'];for (variant in variants) {if (variant[\'variantId\'] == params[\'variantId\']) {return variant;}}","params": {"variantId": '+ variantId +'}}}}}'
                    );
                }
            else {
                return null;
            }
        },
        buildOrderIdsQuery: function(productId) {
            if (angular.isDefined(productId)) {
                return JSON.stringify({
                    size: 0, // no actual hits, only aggregation
                    query: {
                        match: {
                            "productId.keyword": productId
                        }
                    },
                    aggs: {
                        distinct_orderIds: {
                            terms: {
                                field: "orderId.keyword",
                                size: 10000 // adjust as needed
                            }
                        }
                    }
                });
            } else {
                return null;
            }
        },
        
        buildRelatedProductsQuery: function(orderIds, vendorIds, excludeProductId) {
            return JSON.stringify({
                size: 0,
                query: {
                    bool: {
                        must: [
                            { terms: { "orderId.keyword": orderIds } },
                            { terms: { "catalogId.keyword": vendorIds } },
                            { terms: { "productDefinition.keyword": ["Font", "StockDesign","PrintArt","SVG"] } }
                        ],
                        must_not: [
                            { match: { "productId.keyword": excludeProductId } }
                        ]
                    }
                },
                aggs: {
                    frequently_bought_together: {
                        terms: {
                            field: "productId.keyword",
                            size: 2,
                            order: { "_count": "desc" }
                        }
                    }
                }
            });
        },
        //#endregion

        //#region Favorites
        buildFavoriteItemsInfoRequest: function (itemIds, size) {
            return (
                req = '{"track_total_hits": true, "query":{"ids":{"values":["' + itemIds + '"]}},"size":0,"aggs":{"favorites":{"top_hits":{"size":' + size + ',"_source":{"includes":["brand","catalog","name","listPrice","salePrice","variants.listPrice","variants.salePrice","variants.width_in","variants.height_in","variants.variantId","variants.manufacturerPartNumber", "variants.itemId" , "variants.rGB", "variants.variantLabel", "itemId","isBuyable","definitionName","productId", "saleEndDate"]}}}}}'
            )
        },
        buildBrandSampleInfoRequest: function (brands, size,free) {
                if(!free){
                    return (
                    req = '{"track_total_hits": true, "query": {"bool": {"must": [{"range": {"listPrice": {"gt": 0}}},{"terms": {"brand.raw": ["' + brands + '"]}}]}},'
                    + '"size": 0,"aggs": {"groupbyBrands": {"terms": {"size": ' + size + ' , "field": "brand.raw"},"aggs": {"groupbyBrands": {"top_hits": {"size": 10,"_source": {"includes": ["brand","catalog","name","itemId","definitionName"]}}}}}}}'
                    )
                }
                else{
                     return (
                    req = '{"track_total_hits": true, "query": {"bool": {"must": [{"term": {"listPrice":0}},{"terms": {"brand.raw": ["' + brands + '"]}}]}},'
                    + '"size": 0,"aggs": {"groupbyBrands": {"terms": {"size": ' + size + ' , "field": "brand.raw"},"aggs": {"groupbyBrands": {"top_hits": {"size": 10,"_source": {"includes": ["brand","catalog","name","itemId","definitionName"]}}}}}}}'
                    )
                }
          
        },
        buildBrandDefinitionsInfoRequest: function (brands, size,free) {

                    if(!free){
                        return (
                            req = '{"track_total_hits": true, "query": {"bool": {"must": [{"terms": {"brand.raw": ["' + brands + '"]}}], "must_not": [{"terms": {"definitionName": [ "SVG" ]}}]}},"aggs": {"groupbyBrands": {"terms": '
                            + '{"field": "brand.raw","size": ' + size + '},"aggs": {"groupbyDef": {"terms": {"field": "definitionName","size": 3}}}}},"size": 0}'
                        )
                    }
                    else{
                        return (
                        req = '{"track_total_hits": true, "query": {"bool": {"must": [{"terms": {"brand.raw": ["' + brands + '"]}},{"term": {"listPrice":0}}], "must_not": [{"terms": {"definitionName": [ "SVG","Font","DesignPack" ]}}]}},"aggs": {"groupbyBrands": {"terms": '
                        + '{"field": "brand.raw","size": ' + size + '},"aggs": {"groupbyDef": {"terms": {"field": "definitionName","size": 3}}}}},"size": 0}'
                        )
                    }
               
            
        },
        buildMoreItemsFromBrandRequest: function(brand, definition, prdId, isPatch){
                if(["SVG","PrintArt"].indexOf(definition) > -1){
                    return (
                        '{"from":0,"size":60,"_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable","specEmbeddingVector","themeEmbeddingVector"]},"query":{"bool":{"must":[{"term":{"brand":"'+ brand +'"}},{"range": {"listPrice":{"gt":0}}}],"must_not": [{"term": {"_id": {"value": "'+ prdId +'"}}}]}},"sort":[{"_script": {"type": "number","script": {"lang": "painless","source": "Math.random()"},"order": "asc"}},{"saleRank":{"order":"desc"}}]}'
                    );
                }
                else if(isPatch){
                    return (
                        '{"from":0,"size":60,"_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable","specEmbeddingVector","themeEmbeddingVector"]},"query":{"bool":{"must":[{"term":{"brand":"'+ brand +'"}},{"range":{"listPrice": {"gt": 0}}},{"term":{"variants.isPatchEligible": true}}],"must_not":[{"terms":{"definitionName":["SVG","PrintArt"]}},{"term": {"_id": {"value": "'+ prdId +'"}}}]}},"sort":[{"_script": {"type": "number","script": {"lang": "painless","source": "Math.random()"},"order": "asc"}},{"saleRank":{"order":"desc"}}]}'
                    );
                }
                else{
                    return (
                        '{"from":0,"size":60,"_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable","specEmbeddingVector","themeEmbeddingVector"]},"query":{"bool":{"must":[{"term":{"brand":"'+ brand +'"}},{"range":{"listPrice": {"gt": 0}}}],"must_not":[{"terms":{"definitionName":["SVG","PrintArt"]}},{"term": {"_id": {"value": "'+ prdId +'"}}}], "filter": [{"term": {"inStock": true}}]}},"sort":[{"_script": {"type": "number","script": {"lang": "painless","source": "Math.random()"},"order": "asc"}},{"saleRank":{"order":"desc"}}]}'
                    );
                }
            
        },
        //#endregion

        //#region Search
        decodeUrlSearchTerm: function (searchTerm) {
            return decodeUrlSearchTerm(searchTerm);
        },

        normalizeProductSearchTerm: function (searchTerm) {
            return normalizeProductSearchText(searchTerm);
        },

        buildProductSearchBoolQuery: function (searchTerm, definitionName, rawSearchTerm) {
            return buildSharedProductSearchBoolQuery(searchTerm, definitionName, rawSearchTerm);
        },

        // Relevance criteria as a filter, then stable popular sort on listings (default search UX).
        buildListingsProductSearchQuery: function (searchTerm, definitionName, rawSearchTerm, useRelevanceScoring) {
            var boolQuery = buildSharedProductSearchBoolQuery(searchTerm, definitionName, rawSearchTerm);
            if (useRelevanceScoring) {
                return boolQuery;
            }
            return {
                constant_score: {
                    filter: boolQuery,
                    boost: 1.0
                }
            };
        },

        buildListingsPopularSort: function () {
            return [
                { "saleRank": { "order": "desc" } },
                { "rating": { "order": "desc" } },
                { "_id": { "order": "asc" } }
            ];
        },

        buildProductSearchRelevanceSort: function () {
            return [
                { "_score": { "order": "desc" } },
                { "saleRank": { "order": "desc" } },
                { "rating": { "order": "desc" } },
                { "_id": { "order": "asc" } }
            ];
        },

        buildSuggestedProductsRequest: function (searchTerm, definitionName, rawSearchTerm) {
            return JSON.stringify({
                "track_total_hits": true,
                "sort": this.buildListingsPopularSort(),
                "query": this.buildListingsProductSearchQuery(
                    searchTerm,
                    definitionName,
                    rawSearchTerm,
                    false
                ),
                "from": 0,
                "size": 4
            });
        },

        buildSuggestedTermsRequest: function (searchTerm) {
            return (
                req = '{"suggest":{"keywordSuggest":{"text":"' + searchTerm + '","completion":{"field":' +
                '"keywordSuggest","fuzzy":{"fuzziness":1,"prefix_length":3}}}},"size": 0,"sort":[{"rank":{"order":"desc"}}]}'
            );
        },

        buildSuggestedCategoriesRequest: function (searchTerm) {
            return (
                req = '{"track_total_hits": true, "query":{"bool":{"must":[{"range":{"listPrice":{"gte":0.1}}}]}},"size": 0,"aggs":{"categoryList":' +
                '{"terms":{"field":"categoriesList.keyword","include":".*' + searchTerm + '.*","order":{"_count":"desc"},"size":3}}}}'
            );
        },

        buildSuggestedBrandsRequest: function (searchTerm) {
                return (
                    req = '{"track_total_hits": true, "query":{"bool":{"must":[{"wildcard":{"brand":{"value":"*' + searchTerm + '*"}}},' +
                    '{"range":{"listPrice":{"gt":0}}}]}},"aggs":{"brandlist":{"terms":{"field":"brand.raw","size":3}}},"size":0}'
                );
           
        },

        //#endregion
        //#region Product Code
        buildProductByProductCode: function (productCode, catalog) {
            if(angular.isUndefined(catalog)){
                return (
                    req = '{ "query": { "bool": { "must": [ { "term":{ "productId":{ "value":"' + productCode + '"} } } ] } } }'
                );
            }
            else{
                return (
                    req = '{ "query": { "bool": { "must": [ { "term":{ "productId":{ "value":"' + productCode + '"} } }, { "term":{ "catalog": { "value":"' + catalog + '"} } } ] } } }'
                );
            }
        },
        //#endregion

        //#region Brand listings
        buildBrands: function (definition,free) {
                if(definition.toLowerCase() == 'all')
                    {
                        return (
                            req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"range":{"listPrice":{"gt":0}}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                        )
        
                    }
                    else if(!free){
                        return (
                            req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"term":{"definitionName":"' + definition + '"}},{"range":{"listPrice":{"gt":0}}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                        )
                    }
                    else{
                        return (
                            req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"term":{"definitionName":"' + definition + '"}},{"term":{"listPrice":0}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                        )
                    }
        },
        //#endregion

        //#region Embrilliance Brand Products
        buildEmbrillianceProductsRequest: function (size, definitionNames) {
            size = size || 8;
            definitionNames = definitionNames || ["Software"];
            
            var mustArray = [
                '{"term":{"brand":"briton leap"}}',
                '{"term":{"inStock":true}}',
                '{"range":{"listPrice":{"gt":0}}}'
            ];

            // Add definition name filter if provided
            if (definitionNames && definitionNames.length > 0) {
                var prdDefObj = [];
                definitionNames.forEach(function (def) {
                    prdDefObj.push({
                        "term": {
                            "definitionName": def
                        }
                    });
                });
                
                if (prdDefObj.length === 1) {
                    // Single definition - add directly to must
                    mustArray.push(JSON.stringify(prdDefObj[0]));
                } else if (prdDefObj.length > 1) {
                    // Multiple definitions - use should clause
                    mustArray.push('{"bool":{"should":' + JSON.stringify(prdDefObj) + ',"minimum_should_match":1}}');
                }
            }

            return (
                '{"query":{"bool":{' +
                '"must":[' + mustArray.join(',') + ']' +
                '}},"size":' + size + ',"sort":[{"saleRank":{"order":"desc"}},{"rating":{"order":"desc"}}],' +
                '"_source":{"includes":["brand","catalog","name","listPrice","salePrice","clubPrice","itemId","variants.variantId","variants.numberOfDesigns","isBuyable","definitionName","rating","saleRank","yearCreated","videoParts","runTime"]}}'
            );
        },

        buildEmbrillianceStarterPacksRequest: function (size, definitionNames) {
            size = size || 6;
            var mustArray = [
                '{"term":{"categoriesList.keyword":"embrilliance starter packs"}}',
                '{"term":{"inStock":true}}',
                '{"range":{"listPrice":{"gt":0}}}'
            ];
            if (definitionNames && definitionNames.length > 0) {
                var defTerms = definitionNames.map(function (d) {
                    return '{"term":{"definitionName":"' + d + '"}}';
                });
                mustArray.push('{"bool":{"should":[' + defTerms.join(',') + '],"minimum_should_match":1}}');
            }
            return (
                '{"query":{"bool":{"must":[' + mustArray.join(',') + ']}},' +
                '"size":' + size + ',"sort":[{"saleRank":{"order":"desc"}},{"rating":{"order":"desc"}}],' +
                '"_source":{"includes":["brand","catalog","name","listPrice","salePrice","clubPrice","itemId","variants.variantId","variants.numberOfDesigns","isBuyable","definitionName","rating","saleRank","yearCreated","videoParts","runTime"]}}'
            );
        },

        // Category + single definition (e.g. FontPack, DesignPack, ProjectPack) — used by Embrilliance page and home
        buildEmbrillianceStarterPacksByDefinitionRequest: function (categoryKeyword, definitionName, size) {
            size = size || 20;
            var query = {
                "query": {
                    "bool": {
                        "must": [
                            { "term": { "categoriesList.keyword": categoryKeyword } },
                            { "term": { "definitionName": definitionName } },
                            { "term": { "inStock": true } },
                            { "range": { "listPrice": { "gt": 0 } } }
                        ]
                    }
                },
                "size": size,
                "sort": [
                    { "saleRank": { "order": "desc" } },
                    { "rating": { "order": "desc" } }
                ],
                "_source": {
                    "includes": [
                        "brand", "catalog", "name", "listPrice", "salePrice", "clubPrice",
                        "itemId", "variants.variantId", "variants.numberOfDesigns", "isBuyable",
                        "definitionName", "rating", "saleRank", "yearCreated", "videoParts", "runTime",
                        "fontType", "productId", "categoriesList", "designKeywords"
                    ]
                }
            };
            return JSON.stringify(query);
        },
        //#endregion

        buildClubPricesTotalRequest:function (productIds) {
            return (
                req = '{"query":{"ids":{"values":["' + productIds + '"]}},"size":0,"aggs":{"items":{"top_hits":{"size":150,"_source":{"includes":["clubPrice","listPrice","salePrice","variants.variantId", "variants.listPrice", "variants.salePrice", "variants.clubPrice"]}}}}}'
            )
        }


    }
}]);
